// SPDX-FileCopyrightText: 2024 John Livingston <https://www.john-livingston.fr/>
//
// SPDX-License-Identifier: AGPL-3.0-only

export const XMLNS_TASKLIST = 'urn:peertube-plugin-livechat:tasklist'
export const XMLNS_TASK = 'urn:peertube-plugin-livechat:task'
